<template>
  <div class="parkStatistic">
    <div class="bg-light pd-shadow p-bg">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/main' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>操作日志列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="un-content" v-loading="loading">
      <div class="p-bg">
        <div class="bg-fff p-sm search-box pd-shadow">
          <el-row :gutter="24">
            <el-col :span="4" :md="4" :sm="8" class="">
              <div class='search-item'>
                <label class="name">开始时间：</label>
                <div class="items-box">
                  <el-date-picker v-model="params.createdTimebeforeStr" type="date" value-format="yyyy-MM-dd" class="search-item-picker" size="small" placeholder="开始日期"></el-date-picker>
                </div>
              </div>
            </el-col>
            <el-col :span="4" :md="4" :sm="8" class="">
              <div class='search-item'>
                <label class="name">结束时间：</label>
                <div class="items-box">
                  <el-date-picker v-model="params.createdTimeafterStr" type="date" value-format="yyyy-MM-dd" class="search-item-picker" size="small" placeholder="结束日期"></el-date-picker>
                </div>
              </div>
            </el-col>
            <el-col :span="3" :md="3" :sm="8" class="">
              <div class='search-item'>
                <label class="name">学期：</label>
                <div class="items-box" v-loading="termLoading">
                  <el-select size="small" clearable v-model="params.termId" placeholder="选择年级">
                    <el-option label="全部" value=""></el-option>
                    <el-option :value="item.termId" :label="item.termName" v-for="item in termList" :key="item.termId"></el-option>
                  </el-select>
                </div>
              </div>
            </el-col>
            <el-col :span="3" :md="3" :sm="8" class="">
              <div class='search-item'>
                <label class="name">年级：</label>
                <div class="items-box" v-loading="selectLoading">
                  <el-select size="small" clearable v-model="params.gradeCode" @change="changeGrade" placeholder="选择年级">
                    <el-option label="全部" value=""></el-option>
                    <el-option :value="item.gradeCode" :label="item.gradeName" v-for="item in gradeList" :key="item.gradeCode"></el-option>
                  </el-select>
                </div>
              </div>
            </el-col>
            <el-col :span="3" :md="3" :sm="8" class="">
              <div class='search-item'>
                <label class="name">班级：</label>
                <div class="items-box" v-loading="selectLoading">
                  <el-select size="small" clearable v-model="params.classId" placeholder="选择班级">
                    <el-option label="全部" value=""></el-option>
                    <el-option :value="item.classId" :label="item.className" v-for="item in classList" :key="item.classId"></el-option>
                  </el-select>
                </div>
              </div>
            </el-col>
            <el-col :span="3" :md="3" :sm="8" class="">
              <div class='search-item'>
                <label class="name">老师姓名：</label>
                <div class="items-box">
                  <el-input size="small" v-model="params.userName" placeholder="老师姓名"></el-input>
                </div>
              </div>
            </el-col>
            <el-col :span="2">
              <el-button type="primary" icon="el-icon-search" size="small" @click="crrentChangeAction(1)">查询</el-button>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="p-lrbg">
        <div class="bg-fff pd-shadow clearfix">
          <el-table stripe fit ref="singleTable" highlight-current-row size="small" :data="list" tooltip-effect="dark" style="width: 100%">
            <el-table-column show-overflow-tooltip align="center" property="termName" label="学期名称"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" property="studentName" label="学生姓名"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" property="className" label="班级名称"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" property="gradeName" label="年级名称"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" property="icard" label="学籍号"> </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="身份证号" width="200px">
              <template slot-scope="scope">
                <span> {{scope.row.sNumber | valueO }}</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" property="badgeName" label="章名称"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="卡章类型">
              <template slot-scope="scope">
                <span>{{scope.row.medalType | medalTypeStr}}</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" property="creatorName" label="操作老师名称"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="操作类型">
              <template slot-scope="scope">
                <span>{{scope.row.optType | optTypeStr}}</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" property="remarks" label="备注"></el-table-column>
            <el-table-column label="操作" width="100px" align="center">
              <template slot-scope="scope">
                <el-button size="mini" type="text" class="color-info" @click="goInfo(scope.row)">详情</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination background layout="total, prev, pager, next, jumper" :page-size="params.countOfPage" :current-page="params.pageindex" :total="total" @current-change="crrentChangeAction" @prev-click="crrentChangeAction" @next-click="crrentChangeAction"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "medalLogList",

  data() {
    return {
      list: [],
      termList: [],
      gradeList: [],
      classList: [],
      total: 0,
      loading: true,
      termLoading: false,
      selectLoading: false,
      dialogVisible: false,
      params: {
        createdTimebeforeStr: "",
        createdTimeafterStr: "",
        classId: "",
        gradeCode: "",
        userName: "",
        termId: "",
        pageindex: 1,
        countOfPage: 15
      }
    };
  },
  created() {
    let data = this.$util.getOtherPageSaveData();
    if (data) {
      this.params = data;
    }
    this.crrentChangeAction();
  },
  methods: {
    // 分页更改
    crrentChangeAction(val) {
      this.params.pageindex = val;
      this.getListAction();
    },
    //班级配置
    goInfo(row) {
      this.$util.setOtherPageSaveData(this.params);
      this.$router.push({
        path: "/medalLogInfo",
        query: {
          id: row.logId
        }
      });
    },
      //获取班级
    getClassList() {
      this.selectLoading = true;
      this.$http
        .post(this.$api.manageApi.getClassList(), {
          gradeCode: this.params.gradeCode,
          termId: this.params.termId
        })
        .then(res => {
          this.selectLoading = false;
          if (!res) {
            return;
          }
          this.classList = res.data.classList;
        });
    },
    //获取年级
    getGradeList() {
      this.selectLoading = true;
      this.$http.post(this.$api.manageApi.getGradeList(), {}).then(res => {
        this.selectLoading = false;
        if (!res) return;
        this.gradeList = res.data.gradeList;
      });
    },
    //获取学期
    getTermList() {
      this.termLoading = true;
      this.$http
        .post(this.$api.manageApi.getTermList(), {
          status: 1
        })
        .then(res => {
          this.termLoading = false;
          if (!res) return;
          this.termList = res.data.termList || [];
          if (this.termList.length > 0) {
            this.params.termId = this.termList[0].termId;
            this.crrentChangeAction(1);
          } else {
            this.$model.toast("缺少学期信息！", "error");
          }
        });
    },
    changeGrade() {
      this.params.classId = "";
      this.getClassList();
    },
    // 获取列表数据
    getListAction() {
      this.loading = true;
      this.$http
        .post(this.$api.manageApi.getMedalLogList(), this.params)
        .then(res => {
          this.loading = false;
          this.list = res.data.medalLogList;
          this.total = res.data.totalCount || 0;
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.courseStatistic {
  .el-cascader {
    width: 100%;
  }
}
.search-row {
  margin-bottom: 10px;
  .label-title {
    line-height: 32px;
    font-size: 12px;
  }
}
</style>
